'use strict';
const angular = require('angular');

/*@ngInject*/
export function newlineToHtmlFilter($sce) {
  return function(input) {
    if (!input)
      return;

    return $sce.trustAsHtml(input.replace(/\n/g, '<br/>'));
  };
}


export default angular.module('conduu.ap.components.newlineToHtml', [])
  .filter('newlineToHtml', newlineToHtmlFilter)
  .name;



// WEBPACK FOOTER //
// ./client/~ap/components/newline-to-html/newlineToHtml.filter.js